import { ChirpError } from 'rpc-client-utils';
import { ErrorSubCategory } from '../constants/errorSubCategory';

// rpc-client-utils spreads errorType onto ChirpError at runtime but doesn't
// reflect it in the class type definition.
const CHIRP_ERROR_TO_SUBCATEGORY = {
  APPROVAL_ALREADY_EXISTS: ErrorSubCategory.ACTIVE_APPROVAL_ALREADY_EXISTS,
  TRANSITION_NOT_PERMITTED: ErrorSubCategory.APPROVAL_TRANSITION_NOT_PERMITTED,
  NOT_AUTHORIZED: ErrorSubCategory.USER_IS_NOT_AN_APPROVER,
  APPROVER_INVALID: ErrorSubCategory.APPROVER_NOT_VALID,
  APPROVALS_NOT_ENABLED: ErrorSubCategory.APPROVALS_NOT_ENABLED
};
const findChirpError = (error, depth = 0) => {
  if (depth > 4 || !error || typeof error !== 'object') return undefined;
  if (error instanceof ChirpError) return error;
  if ('cause' in error) {
    return findChirpError(error.cause, depth + 1);
  }
  return undefined;
};
export const getErrorSubCategoryFromError = error => {
  const chirpError = findChirpError(error);
  if (chirpError) {
    const {
      errorType
    } = chirpError;
    if (errorType) {
      var _CHIRP_ERROR_TO_SUBCA;
      return (_CHIRP_ERROR_TO_SUBCA = CHIRP_ERROR_TO_SUBCATEGORY[errorType]) !== null && _CHIRP_ERROR_TO_SUBCA !== void 0 ? _CHIRP_ERROR_TO_SUBCA : ErrorSubCategory.UNKNOWN_ERROR;
    }
  }
  return ErrorSubCategory.UNKNOWN_ERROR;
};